import React, { Component } from 'react';
import moment from 'moment';

import CreateReminder from '../CreateReminder';
import Loading from '../../common/Loading';
import DeleteReminderModal from './DeleteModal';
import ReactTooltip from 'react-tooltip';

import deleteIcon from '../../../assets/images/delete.svg';
import './index.scss';
import utils from '../../../lib/utils';

const days_duration = {
  'P0D':'Same Day',
  'P1D':'1 Day before',
  'P2D':'2 Day before',
  'P3D':'3 Day before',
  'P4D':'4 Day before',
  'P5D':'5 Day before',
  'P6D':'6 Day before',
  'P7D':'1 Week before',
};
const days_duration_array = [
  { value: 'P0D', label: 'Same Day' },
  { value: 'P1D', label: '1 Day before' },
  { value: 'P2D', label: '2 Days before' },
  { value: 'P3D', label: '3 Days before' },
  { value: 'P4D', label: '4 Days before' },
  { value: 'P5D', label: '5 Days before' },
  { value: 'P6D', label: '6 Days before' },
  { value: 'P7D', label: '1 Week before' },
];
export default class AppointmentReminder extends Component{
    constructor(props) {
        super(props);
        this.state = {
          modelopen: false,
          loading:false,
          reminders:[],
          deletemodalopen:false,
          selectedForDelete:null,
          showDeleteSucess:false
        }
        };
    createDisabled = ()=>{
      return false;
    }
    onCreateClick=()=>{
      this.setState({
        modelopen:true
      })
    }
    closeCampaignModel=()=>{
      this.setState({
        modelopen:false
      })
    }

    componentDidMount(){
      this.props.getAppointmentReminder();
    }
    
    componentWillReceiveProps(nextProps){
      if(nextProps?.appointmentreminder?.loading == false && this?.props?.appointmentreminder?.loading !== nextProps?.appointmentreminder?.loading ){
        const { reminders, loading} = nextProps.appointmentreminder;
        this.setState({
          loading,
          reminders
        })
      }
      if(nextProps?.appointmentreminder?.reminders!== this.props?.appointmentreminder?.reminders){
        const { reminders} = nextProps.appointmentreminder;
        this.setState({
          reminders
        })
      }
      console.log('nextProps',nextProps.appointmentreminder);
      if(nextProps?.appointmentreminder?.loading){
        console.log('Loading...');
        this.setState({
          loading:true
        })
      }

      if(nextProps?.appointmentreminder?.deleteloading===false && nextProps?.appointmentreminder?.deleteloading!== this.props?.appointmentreminder?.deleteloading){
        this.closeDeleteModal();
        console.log('DELETE Reminder Close', nextProps?.appointmentreminder);
        if(nextProps?.appointmentreminder?.deletesuccess){
        this.setState({
          showDeleteSucess: true,
        });
        setTimeout(() => {
          this.setState({
            showDeleteSucess: false,
          });
        }, 3000);
        }
      }
    }
    getServiceNameforId=(services)=>{
      const { business } = this.props;
      const filteredServices = business?.details?.services?.filter((service) => service.kind === 'SESSION');
      const serviceIds = filteredServices?.map(service=>service.id);
      const remidersServices = services?.map(service=>service.id);
      if(utils.arraysHaveSameValues(serviceIds,remidersServices)){
        return 'All';
      }

      let serviceList = '';
      if(utils.isEmptyObject(business?.serviceById)){
        return '';
      } else {
      for(let i=0;i<services.length;i++){
        serviceList+= business?.serviceById[services[i].id]?.name+' ';
        serviceList+= i<services.length-1?', ':'';
      }
      return serviceList || '';
      }
    }
    goToList=()=>{
      this.props.history.goBack();
    }
    openDeleteModal=(reminder)=>{
      this.setState({
        selectedForDelete:reminder,
        deletemodalopen: true
      })
    }
  getDurationName = (reminder) => {
    const durations = reminder?.days_before || [];
    const duration_channel_map = reminder?.reminder_types_by_period || [];
    let durationList = '';
    const sorteddurations = durations.sort((a, b) => {
      const durationA = moment.duration(a).asDays();
      const durationB = moment.duration(b).asDays();
      return durationB - durationA;
    });
    let voiceEnabled = false;
    const features = utils.getCookie('features');
    if (features.includes("VOICE_REMINDER_ENABLED")) {
      voiceEnabled = true;

    }
    for (let i = 0; i < sorteddurations.length; i++) {
      durationList +=
        days_duration_array?.filter((duration) => duration.value === sorteddurations[i])[0]
        .label + ((voiceEnabled && duration_channel_map[sorteddurations[i]] === 'VOICE_REMINDER') ? '(voice) ' : '(SMS)') + ' ';
      durationList += i < sorteddurations.length - 1 ? ', ' : '';
    }
    return durationList || '';
  };
    closeDeleteModal=()=>{
      this.setState({
        selectedForDelete:null,
        deletemodalopen: false
      })
    }
    getFilteredReminder=(reminders)=>{
      return reminders.filter(reminder=>reminder.status!=='DELETED')|| [];
    }
    deleteReminder=()=>{
      const { reminders, selectedForDelete } = this.state;
      const reminderCopy = [...reminders];
      const deleteIndex =  reminderCopy.findIndex(x => x.services ===selectedForDelete.services);
      reminderCopy[deleteIndex].status = 'DELETED';
      const data = {
        appointment_reminders: reminderCopy
      };
      this.props.deleteAppointmentReminder(data);
    }

    getServiceFiltered = (services) => {
      if(services){
      const { reminders } = this.state;
      const filtered_reminder = this.getFilteredReminder(reminders);
      let existingservices = [];
      for (let i = 0; i < filtered_reminder.length; i++) {
        if(filtered_reminder[i].services.length>0){
          let serviceIds = filtered_reminder[i].services.map((service) => service.id);
          existingservices = [...existingservices, ...serviceIds];
        }else{
          return true;
        }
      }
      let filtedService = services.filter(
        (service) => !existingservices.includes(service.id),
      );
      filtedService = filtedService.filter((service) => service.kind === 'SESSION');
      console.log('filtedService', filtedService);
      return filtedService.length === 0;
      }else{
        return true;
      }
    };
  
      render() {
        const { modelopen, loading, reminders, deletemodalopen, showDeleteSucess } = this.state;
        const { business, appointmentreminder, auth } = this.props;
        const { deleteloading, deletesuccess } = appointmentreminder;
        const features = utils.getCookie('features');
        const filteredReminders = this.getFilteredReminder(reminders);
        const isFeatureEnabled = features.includes("VOICE_REMINDER_ENABLED");
        console.log('filteredReminders',filteredReminders);
        return (<div className="reminder-list">
      {loading?
          (<div className="add-campaign_loader">
            <Loading />
          </div>):
          (<>
            <div className='reminder-list_title'>
            <div className="reminder-list_title_back">
              <div className="title" onClick={this.goToList} >
                  <span className="material-icons">arrow_back</span>
                  <span className="back-text">Go back</span>
              </div>
            </div>
              <div className="reminder-list_title_content">
                <div className="title">Reminder setup</div>
                <div>
                  <button className="add_reminder" data-class="multiline-tooltip" data-multiline={false} data-place={'top'} data-tip={'Reminders are added for all services.'} data-tip-disable={!this.getServiceFiltered(business?.details?.services)}  style={{ opacity: (this.getServiceFiltered(business?.details?.services) ? 0.5 : 1) }} disabled={this.getServiceFiltered(business?.details?.services)} onClick={this.onCreateClick}>+ Add reminder schedule</button>
                  {/* <button className="save" style={{ opacity: (this.createDisabled() ? 0.5 : 1) }} disabled={this.createDisabled()}>Save</button> */}
                </div>
                <ReactTooltip />
                </div>
            </div>
           
            <div className='reminder-list_conv-list'>
                  <div className='reminder-list_conv-list_content'>
                    <div className='column-titles'>
                      <div className='title time'>NUMBER OF REMINDERS</div>
                      <div className='title service-type'>SCHEDULE</div>
                      <div className='title client'>SERVICES</div>
                      <div className='title empty'></div>
                    </div>
                    <div className='list-container'>
                    {filteredReminders.length<1?
                    (<div className='column-data'>
                      <div className='no-reminder'>No reminders. Add reminder schedule to get started.</div> 
                    </div>):(<>
                    
                    {filteredReminders.map(reminder=>{
                      return(<div className='column-data'>
                      <div className='time'>
                        <div className='schedule-time'>{reminder.days_before.length} reminders</div>
                      </div>
                        <div className='service-type'>
                          {this.getDurationName(reminder)}
                       {/* {reminder.days_before.map((days,index)=><div> { days_duration[days]}{index!==reminder.days_before.length-1 && <span>,&nbsp;</span>}</div>)} */}
                      </div>
                      <div className='client'>
                        <div className='email'> {reminder.services.length>0?this.getServiceNameforId(reminder.services):'All'} </div>
                      </div>
                      <div className='empty'>
                      <img src={deleteIcon} className='delete-icon' onClick={()=>this.openDeleteModal(reminder)}/>
                      </div>
          
                    </div>

                      )
                    })}
                    </>)}
                    </div>
                  </div>
            </div>
            {showDeleteSucess && 
            <div className="copy-webhook">
                      <span className="tick-mark"><i className="material-icons">check</i></span>
                      Reminder schedule was deleted
                      
              </div>}
           {modelopen && <CreateReminder reminders={reminders} business={business} modelopen={modelopen} closeCampaignModel={this.closeCampaignModel}  {...this.props} /> }
           {deletemodalopen  && <DeleteReminderModal  modelopen={deletemodalopen} closeServiceModal={this.closeDeleteModal} deleteReminder={this.deleteReminder} appointmentreminder={appointmentreminder}/>}
        </>)}
        </div>)
        }
}